export default {
  focus: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    overflow: 'hidden'
  },
  circle: {
    position: 'absolute',
    top: '50%',
    left: 12,
    zIndex: 0,
    width: 0,
    height: 0,
    transform: 'translateY(-50%)',
    transition: 'all 0.4s cubic-bezier(1,.13,.83,.67)'
  },
  circleInner: {
    position: 'relative',
    width: '100%',
    paddingBottom: '100%',
    display: 'block'
  },
  circleInnerBefore: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    background: '#FBFBFB',
    borderRadius: '50%'
  }
};